try{self['workbox:google-analytics:4.3.1']&&_()}catch(e){}// eslint-disable-line